// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createWidgetizedDrawer } from './implementation';
export const InternalDrawer = createWidgetizedDrawer();
//# sourceMappingURL=internal.js.map